module.exports = __webpack_public_path__ + "61c6d8de6fa106ee812ea48d45d6c228.jpg";